var map = {
	"./schema_arrow_white.png": "0ad1",
	"./schema_circle_white.png": "0452",
	"./schema_eraser_white.png": "4ed3",
	"./schema_line_white.png": "a4cd",
	"./schema_pen_white.png": "dbfd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "94a1";